<!-- eslint-disable vue/no-template-key -->
<!-- eslint-disable vue/no-unused-vars -->
<!-- eslint-disable vue/require-v-for-key -->
<template>
  <v-container>
    <div>
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div
        v-else
      >
        <div
          id="idTable"
          style="overflow-x: auto;"
        >
          <table
            style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
            class="elevation-1"
          >
            <thead>
              <tr>
                <th
                  id="headerPrincipalExpand"
                  style="text-align: center;"
                />
                <th
                  id="headerPrincipal"
                  style="text-align: center;"
                >
                  Linha Produção
                </th>
                <th
                  id="headerPrincipal"
                  style="text-align: center;"
                >
                  Total Quantidade
                </th>
                <th
                  id="headerPrincipal"
                  style="text-align: center;"
                >
                  Total Peças
                </th>
              </tr>
            </thead>
            <tbody
              v-for="(item, index) in evolucaoLinhas"
              :key="item.linha"
            >
              <!-- Linha principal -->
              <tr>
                <td style="text-align: center;">
                  <button @click="toggleExpand(index)">
                    {{ expanded.includes(index) ? '▲' : '▼' }}
                  </button>
                </td>
                <td style="text-align: center;">
                  {{ item.linha }}
                </td>
                <td style="text-align: right;">
                  {{ item.quantidade }}
                </td>
                <td style="text-align: right;">
                  {{ item.pecas }}
                </td>
              </tr>

              <!-- Linha expandida -->
              <tr v-if="expanded.includes(index)">
                <td :colspan="computedHeaders.length + 1">
                  <!-- Tabela expandida -->
                  <div style="overflow-x: auto; width: 100%;">
                    <table
                      style="width: max-content; table-layout: fixed; border-collapse: collapse; margin-top: 10px;"
                      class="elevation-1 table-custom"
                    >
                      <thead>
                        <tr>
                          <th style="min-width: 300px;" />
                          <th
                            v-for="(header, hIndex) in headersDatas"
                            :key="hIndex"
                            :colspan="3"
                            class="text-center"
                          >
                            {{ header.text }}
                          </th>
                        </tr>
                        <tr>
                          <th
                            class="text-center"
                            style="min-width: 300px;"
                            :style="getHeaderCellStyle('produto')"
                          >
                            Produtos
                          </th>
                          <template
                            v-for="(header, hIndex) in headersDatas"
                          >
                            <th
                              style="width: 90px; text-align: center;"
                              :style="getHeaderCellStyle('quantidade')"
                            >
                              Quantidade
                            </th>
                            <th
                              style="width: 90px; text-align: center;"
                              :style="getHeaderCellStyle('peca')"
                            >
                              Peças
                            </th>
                            <th
                              style="width: 90px; text-align: center;"
                              :style="getHeaderCellStyle('preco')"
                            >
                              Preço
                            </th>
                          </template>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(produto, pIndex) in item.dadosProdutos"
                          :key="pIndex"
                        >
                          <td
                            v-for="(value, key) in produto"
                            :key="key"
                            :style="getCellStyle(key)"
                          >
                            {{ value }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import Producao from '../../../../../services/producaosimples'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'RelatorioProducaoSimples',
    emits: [],
    components: {
      DashboardCoreSnackbar: () => import('../../core/Snackbar'),
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      dataInicial: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      empresa: [],
      supervisor: [],
      vendedor: [],
      area: [],
      rede: [],
      expanded: [],
      headersProducaoLinhas: [],
      headersProducaoProdutos: [],
      header: [
        { text: 'Linha Produção', value: 'linha', class: 'black--text title' },
        { text: 'Total Quantidade', value: 'quantidade', align: 'right', class: 'black--text title' },
        { text: 'Total Peças', value: 'pecas', align: 'right', class: 'black--text title' },
      ],
      headerExpand: [],
      evolucaoLinhas: [],
      evolucaoProdutos: [],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      headersDatas: [],
      widthTotal: 0,
      calculationDone: false,
    }),

    computed: {
      computedHeaders () {
        return this.expanded.length > 0 ? this.headerExpand : this.header
      },
    },

    created () {
      eventEmit.$on('update-form-producao-simples', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-form-producao-simples', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, empresa) {
        this.dataInicial = primeiroDia
        this.dataFinal = dataFinal
        this.empresa = empresa

        this.showRelatorioProducaoSimples()
      },

      async showRelatorioProducaoSimples () {
        this.loading = true

        this.evolucaoLinhas = []
        this.evolucaoProdutos = []
        this.expanded = []
        this.calculationDone = false
        this.widthTotal = 0
        this.headerExpand = []

        await Producao.showProducaoSimples(this.dataInicial, this.dataFinal, this.empresa, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.headersProducaoLinhas = resposta.data.headers

            this.headersProducaoProdutos = resposta.data.headersProduto

            this.headersDatas = resposta.data.headersDatas

            this.headerExpand = resposta.data.headerExpand

            this.evolucaoLinhas = resposta.data.dados.map((item) => {
              var listaFaturamentoSupervisor = ({
                linha: item.linha,
                quantidade: item.quantidade,
                pecas: item.totalPeca,
                dadosProdutos: item.dadosProdutos,
              })

              return listaFaturamentoSupervisor
            })
          } else if (resposta.data.msg === 'Não há produção no período selecionado.') {
            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      getHeaderCellStyle (value) {
        if (value === 'quantidade') {
          return {
            border: '1px solid black',
            'border-right': 'none',
            'border-left': 'none',
            'border-bottom': 'none',
            textAlign: 'center',
            width: '90px',
            minWidth: '90px',
          }
        } else if (value === 'peca') {
          return {
            border: '1px solid black',
            'border-left': 'none',
            'border-bottom': 'none',
            'border-right': 'none',
            textAlign: 'center',
            width: '90px',
            minWidth: '90px',
          }
        } else if (value === 'preco') {
          return {
            border: '1px solid black',
            'border-left': 'none',
            'border-bottom': 'none',
            textAlign: 'center',
            width: '110px',
            minWidth: '110px',
          }
        } else if (value === 'produto') {
          return {
            border: '1px solid black',
            'border-bottom': 'none',
            textAlign: 'center',
            width: '300px',
            minWidth: '300px',
          }
        }

        return {}
      },

      getCellStyle (columnName) {
        if (columnName.startsWith('quantidade')) {
          return {
            border: '1px solid black',
            'border-right': 'none',
            'border-left': 'none',
            'border-bottom': 'none',
            textAlign: 'right',
            width: '90px',
            minWidth: '90px',
          }
        } else if (columnName.startsWith('peca')) {
          return {
            border: '1px solid black',
            'border-left': 'none',
            'border-bottom': 'none',
            'border-right': 'none',
            textAlign: 'right',
            width: '90px',
            minWidth: '90px',
          }
        } else if (columnName.startsWith('preco')) {
          return {
            border: '1px solid black',
            'border-left': 'none',
            'border-bottom': 'none',
            textAlign: 'right',
            width: '90px',
            minWidth: '90px',
          }
        } else if (columnName.startsWith('produto')) {
          return {
            border: '1px solid black',
            'border-bottom': 'none',
            textAlign: 'center',
            width: '300px',
            minWidth: '300px',
          }
        }

        return {}
      },

      toggleExpand (index) {
        const i = this.expanded.indexOf(index)
        if (i > -1) {
          this.expanded.splice(i, 1)
        } else {
          this.expanded.push(index)
        }
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  .table-custom {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #ccc; /* Borda externa */
  }

  .table-custom th,
  .table-custom td {
    border: 1px solid #333; /* Bordas internas */
    padding: 8px;
    text-align: center;
  }

  .table-custom th {
    background-color: #f9f9f9;
    font-weight: bold;
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  #headerPrincipal {
    width: 100%;
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  #headerPrincipalExpand {
    width: 30%;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

   @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
      max-width: 373px !important;
      margin: 0 0 0 -0.7rem
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }
</style>
